import { useEffect } from 'react';
import MainLayout from '../layouts/MainLayout';
import { Link, useLocation } from 'react-router-dom';
import economyimg from '../assets/img/economy.png';
import originimg from '../assets/img/origin.jpg';
import womanImg from '../assets/img/woman.jpg';
import ganeshImg from '../assets/img/ganesha.jpg';
import mahawarImg from '../assets/img/mahawar-sabha-building-2.jpg';
import rajeevImg from '../assets/img/testimonials/rajeev-gupta.png';
import nareshImg from '../assets/img/testimonials/Naresh-Gupta.jpeg';
import subodhImg from '../assets/img/testimonials/Subodh-Gupta.jpeg';
import kapilImg from '../assets/img/testimonials/Kapil-Gupta.jpeg';
import amitImg from '../assets/img/testimonials/Amit-Gupta.jpeg';
import niranjanImg from '../assets/img/testimonials/Niranjan-Lal-Gupta.jpeg';
import anilImg from '../assets/img/testimonials/Anil-Kumar-Gupta.jpeg';
import tejparkashImg from '../assets/img/testimonials/Tejparkash.jpeg';
import HemantguptaImg from '../assets/img/testimonials/Hemant-Gupta.jpeg';

function Home() {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.substring(1));
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100); // Small timeout to ensure DOM is fully rendered before scrolling
            }
        } else {
            window.scrollTo(0, 0); // Scroll to top if no hash is present
        }
    }, [hash]);

    return (
        <MainLayout>
            <section id="heroCarousel" className="carousel slide carousel-fade hero-section position-relative vh-100" data-bs-ride="carousel" data-bs-interval="5000">
                {/* Dark Overlay */}
                <div className="hero-overlay position-absolute top-0 start-0 w-100 h-100 z-1"></div>

                <div className="carousel-inner h-100 z-2 position-relative">
                    {/* Slide 1: Welcome & Intro */}
                    <div className="carousel-item active h-100">
                        <div className="d-flex align-items-center justify-content-center text-center text-white h-100">
                            <div className="container position-relative px-5 px-md-3">
                                <div className="row justify-content-center">
                                    <div className="col-lg-10 col-xl-8">
                                        <h3 className="h5 fw-medium text-uppercase tracking-wide mb-3 text-light ">
                                            Mahawar Vaishya (Bania) Community
                                        </h3>
                                        <h1 className="display-2 fw-bolder mb-4 animated-gradient-text text-uppercase">
                                            Mahawar Sabha (Reg.), Rewari
                                        </h1>
                                        <p className="lead  fw-medium text-light " style={{ maxWidth: '750px' }}>
                                            A recognized cultural and welfare society — committed to preserving traditions, nurturing family unity, and supporting community well‑being.
                                        </p>
                                        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                                            <a href="#about" className="btn btn-danger btn-lg rounded-pill px-5 py-3 hero-btn solid-btn shadow-lg">
                                                About Us
                                            </a>
                                            <a href="#contact" className="btn btn-outline-light btn-lg rounded-pill px-5 py-3 hero-btn outline-btn shadow-lg">
                                                Contact Us
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Slide 2: Core Objectives */}
                    <div className="carousel-item h-100">
                        <div className="d-flex align-items-center justify-content-center text-center text-white h-100">
                            <div className="container position-relative px-5 px-md-3">
                                <div className="row justify-content-center">
                                    <div className="col-lg-10 col-xl-9">
                                        <h3 className="h5 fw-medium text-uppercase tracking-wide mb-3 text-light ">
                                            Our Core Objectives
                                        </h3>
                                        <h1 className="display-2 fw-bolder mb-4 animated-gradient-text text-uppercase">
                                            Empowering Our Community
                                        </h1>
                                        <p className="lead  fw-medium text-light " style={{ maxWidth: '850px' }}>
                                            Committed to <strong>Educational Support</strong>, <strong>Social Welfare</strong>, and <strong>Cultural Preservation</strong>. We organize medical camps, food drives, scholarships, and festivals to uplift every member of our society.
                                        </p>
                                        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                                        <a href="#objectives" className="btn btn-danger btn-lg rounded-pill px-5 py-3 hero-btn solid-btn shadow-lg">
                                                View Our Initiatives
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Slide 3: Infrastructure & Youth */}
                    <div className="carousel-item h-100">
                        <div className="d-flex align-items-center justify-content-center text-center text-white h-100">
                            <div className="container position-relative px-5 px-md-3">
                                <div className="row justify-content-center">
                                    <div className="col-lg-10 col-xl-8">
                                        <h3 className="h5 fw-medium text-uppercase tracking-wide mb-3 text-light ">
                                            Infrastructure & Leadership
                                        </h3>
                                        <h1 className="display-2 fw-bolder mb-4 animated-gradient-text text-uppercase">
                                            Building a Stronger Future
                                        </h1>
                                        <p className="lead  fw-medium text-light " style={{ maxWidth: '800px' }}>
                                            Managing the Mahawar Sabha Building as a hub for events. We encourage <strong>Youth Engagement</strong> and invite families to join our growing Member Directory to help lead community development.
                                        </p>
                                        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                                            <Link to="/member-list" className="btn btn-danger btn-lg rounded-pill px-5 py-3 hero-btn solid-btn shadow-lg">
                                                Member Directory
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Subtle Carousel Arrows */}
                <button className="carousel-control-prev border-0 bg-transparent position-absolute start-0 top-50 translate-middle-y px-1 px-md-4 text-white opacity-50 hover-opacity-100 transition-opacity z-3 " type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon hero-carousel-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next border-0 bg-transparent position-absolute end-0 top-50 translate-middle-y px-1 px-md-4 text-white opacity-50 hover-opacity-100 transition-opacity z-3" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon hero-carousel-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </section>

            {/* Features Section */}
            <section id="features" className="features-section py-5 bg-light">
                <div className="container py-4">
                    <div className="row g-4 text-center">
                        {/* Feature 1 */}
                        <div className="col-md-6 col-lg-3">
                            <div className="feature-box p-4 h-100">
                                <div className="icon-box mx-auto mb-4 d-flex align-items-center justify-content-center">
                                    <i className="bi bi-people fs-2"></i>
                                </div>
                                <h4 className="fw-bold mb-3 feature-title fs-5">Community Unity</h4>
                                <p className=" mb-0 fs-6">Strengthening social bonds and fostering harmony among Mahawar families.</p>
                            </div>
                        </div>
                        {/* Feature 2 */}
                        <div className="col-md-6 col-lg-3">
                            <div className="feature-box p-4 h-100">
                                <div className="icon-box mx-auto mb-4 d-flex align-items-center justify-content-center">
                                    <i className="bi bi-book fs-2"></i>
                                </div>
                                <h4 className="fw-bold mb-3 feature-title fs-5">Educational Support</h4>
                                <p className=" mb-0 fs-6">Offering scholarships, guidance, and career opportunities for our youth.</p>
                            </div>
                        </div>
                        {/* Feature 3 */}
                        <div className="col-md-6 col-lg-3">
                            <div className="feature-box p-4 h-100">
                                <div className="icon-box mx-auto mb-4 d-flex align-items-center justify-content-center">
                                    <i className="bi bi-heart-pulse fs-2"></i>
                                </div>
                                <h4 className="fw-bold mb-3 feature-title fs-5">Social Welfare</h4>
                                <p className=" mb-0 fs-6">Organizing medical camps, food drives, and support for underprivileged families.</p>
                            </div>
                        </div>
                        {/* Feature 4 */}
                        <div className="col-md-6 col-lg-3">
                            <div className="feature-box p-4 h-100">
                                <div className="icon-box mx-auto mb-4 d-flex align-items-center justify-content-center">
                                    <i className="bi bi-bank fs-2"></i>
                                </div>
                                <h4 className="fw-bold mb-3 feature-title fs-5">Cultural Preservation</h4>
                                <p className=" mb-0 fs-6">Celebrating festivals and keeping our rich traditions alive for future generations.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* =========================================================
          Premium "About Mahawar Sabha" Heritage Section 
          ========================================================= */}
            <div id="about" className="bg-heritage-cream overflow-hidden">

                {/* 1. Hero Header */}
                <section className="container py-5 mt-4">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6 z-2">
                            <span className="badge bg-heritage-gold text-dark mb-3 px-3 py-2 rounded-pill fw-bold shadow-sm">
                                ABOUT US
                            </span>
                            <h2 className="display-4 fw-bold text-heritage-maroon mb-3 text-uppercase">
                                Mahawar Sabha
                            </h2>
                            <p className="lead fw-medium">
                                Learn More About Mahawar Sabha (Reg.), Rewari.
                            </p><p className="lead  fw-medium">
                                In Sanskrit <em>vanij</em> means trader or merchant. The name Bania is derived from this word, hence Banias are large trading community.
                                <br></br><strong>Existence of Bania :</strong> Approximately, there are 25 million of Banias and they live in the states of Uttar Pradesh, Rajasthan, Gujarat, Andhra Pradesh, Maharashtra, Madhya Pradesh, Delhi, West Bengal, Haryana, Bihar, Karnataka, Punjab, Orissa, Tamil Nadu, Chandigarh and Assam.
                            </p></div>
                        <div className="col-lg-6 position-relative">
                            <div className="decorative-pattern-bg position-absolute top-50 start-50 translate-middle w-100 h-100 z-0"></div>
                            <div className="img-wrapper rounded-4 shadow-elegant overflow-hidden position-relative z-1 hover-lift">
                                <img src={mahawarImg} alt="Indian Temple" className="img-fluid w-100 img-heritage object-fit-cover" />
                                <div className="soft-overlay"></div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 2. Main Introduction Card */}
                <section className="container py-5">
                    <div className="glass-card rounded-4 p-4 p-md-5 shadow-elegant border-gold position-relative">
                        <div className="text-center mb-5">
                            <div className="icon-gold-circle mx-auto mb-3 shadow-sm" style={{ width: '80px', height: '80px', fontSize: '32px' }}>
                                <i className="bi bi-bank2"></i>
                            </div>
                            <h2 className="fw-bold text-heritage-maroon">Welcome to Mahawar Samaaj – United in Culture, Committed to Service</h2>
                            <p className="mx-auto text-center fw-medium fs-5" style={{ maxWidth: '800px' }}>
                                Mahawar Sabha (Reg.), Rewari unites the Mahawar Vaishya community, preserving traditions and supporting members through social and educational initiatives.
                            </p>
                        </div>

                        <div className="row g-4 text-center mt-2">
                            {[
                                { icon: 'bi-bank', title: 'Preserving Traditions' },
                                { icon: 'bi-house-heart', title: 'Dharamshalas & Bhawans' },
                                { icon: 'bi-person-up', title: 'Youth Leadership' },
                                { icon: 'bi-geo-alt', title: 'Pilgrim Support' },
                                { icon: 'bi-heart-pulse', title: 'Welfare Programs' },
                                { icon: 'bi-book', title: 'Education Promotion' }
                            ].map((item, index) => (
                                <div className="col-6 col-lg-4" key={index}>
                                    <div className="bg-white p-4 rounded-4 shadow-sm border-gold hover-lift h-100">
                                        <div className="icon-gold-circle mx-auto mb-3">
                                            <i className={`bi ${item.icon}`}></i>
                                        </div>
                                        <h6 className="fw-bold text-heritage-maroon mb-0">{item.title}</h6>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* 3. Origin of Bania Section */}
                <section className="container py-5">
                    <div className="row g-5 align-items-center mb-5">
                        <div className="col-lg-5">
                            <div className="img-wrapper rounded-4 shadow-elegant overflow-hidden hover-lift border-gold">
                                <img src= {originimg} alt="Maharaja Agrasen Heritage" className="img-fluid w-100 img-heritage object-fit-cover" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <h2 className="fw-bold text-heritage-maroon mb-4">Origin of Bania</h2>
                            <div className="info-card p-4 rounded-3 shadow-sm mb-4 hover-lift">
                                <h5 className="text-heritage-maroon fw-bold mb-2">Historical Roots & Varna</h5>
                                <p className=" mb-0 fs-6" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                                    The Vaishyas are in third position in Hindu caste system. Vaishyas supposedly evolved from Brahma’s thighs. The Vaishya’s duty was to ensure the community’s prosperity through trade and merchandising. The colour associated with this Varna is yellow, which symbolises Rajas/Tamas, meaning quality in general. It is believed that Bania community is originated 5000 years ago when an ancestor Maharaja Agrasen (or Ugarsain) of Agroha, Haryana divided the Vaishya community into eighteen clans. Some traditional North Indian surnames include Aggarwal, Gupta, Lala, Seth, Vaish, Mahajan, Sahu and Sahukar.
                                </p>
                            </div>
                            <div className="info-card p-4 rounded-3 shadow-sm hover-lift">
                                <h5 className="text-heritage-maroon fw-bold mb-2">Subgroups & Society</h5>
                                <p className="mb-0 fs-6" style={{ fontSize: '0.9rem', lineHeight: '1.6' }}>
                                    There are six subgroups among the Bania – the Bisa (Vaish Agarwal), Dasa (Gata Agarwal), Saralia, Saraogi (Jain), Maheshwari (Shaiva) and Oswal. The Bisa believe that they are the descendents of the seventeen snake daughters of Bashak Nag (cobra) who married seventeen sons of Ugarsain. The husbands slept with the handmaidens of the snake daughters resulting in Dasa offspring. The Bisa (twenty) consider themselves of a higher status to the Dasa (ten). The Saralia are an offshoot of the Bisa who migrated to Saralia, near Ambala in Haryana. <br /><br />
                                    According to the Hindu caste system the Bania (Vaishya) are third in hierarchy below Rajputs and Brahmins but higher than all other castes. Due to the caste status Banias accept food and water from higher castes but will not offer food and water in return, but they will give to lower castes, but will not accept food from them. They speak Hindi amongst themselves as well as the regional language of the states they reside in.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Community Subgroups */}
          <div className="row g-3 justify-content-center mt-2">
            {[
                { title: 'Mahawar', desc: 'Our community, linked to Vaishya lineage' },
                { title: 'Agarwal', desc: 'Includes Bisa, Dasa, and other branches' },
                { title: 'Maheshwari', desc: '72 traditional gotras' },
                { title: 'Oswal', desc: 'Originating from Osian, Rajasthan' },
                { title: 'Khandelwal', desc: 'Prominent Vaishya subgroup' },
                { title: 'Porwal / Paurwal', desc: 'Historical trading community' },
                { title: 'Jain Bania', desc: 'Saraogi, Saralia, etc.' },
                { title: 'Extended Vaishya Network', desc: 'Gupta, Gahoi, Kasliwal, Singhal, Goenka, Mittal, Bansal, Garg, Jindal, Aggarwal' }
            ].map((group, idx) => (
              <div className="col-12 col-sm-6 col-md-4 col-lg-3 text-center" key={idx}>
                <div className="bg-white p-3 rounded-4 shadow-sm border-gold hover-lift h-100 d-flex flex-column justify-content-center">
                  <h6 className="text-heritage-maroon fw-bold mb-1">{group.title}</h6>
                  <span className="  mb-0 fs-6">{group.desc}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* 4. Beliefs Section */}
                <section className="container py-5">
                    <div className="row g-5 align-items-center flex-lg-row-reverse">
                        <div className="col-lg-5">
                            <div className="img-wrapper rounded-4 shadow-elegant overflow-hidden hover-lift">
                                <img src={ganeshImg} alt="Lord Ganesha" className="img-fluid w-100 img-heritage object-fit-cover" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <h2 className="fw-bold text-heritage-maroon mb-4">Our Deep-Rooted Beliefs</h2>
                            <div className="row g-4 ">
                                {[
                                    { title: 'Reverence & Deities', desc: 'The Bania worships all main Hindu gods and goddesses like Shiva, Parvati Vishnu, Krishna, Rama, Durga and Lakshmi is held in special reverence and so is Ganesh or Ganpati. These deities are prominently displayed and worshiped in their work places and homes.' },
                                    { title: 'Diwali & Prosperity', desc: "On the festival of Diwali the Bania close their old account books and open new ledgers which they dedicate and adorn with Ganesh's image and an invocation to him on the front page. A silver or gold rupee is worshipped as an emblem of Lakshmi. The Bania like to gamble on Diwali as an omen of good luck. No money is loaned on this day." },
                                    { title: 'Festivals & Rituals', desc: 'The Bania celebrate all major Hindu festivals like Diwali, Holi, Janamashtami, Dussehra, Ramnavmi, Maha Sivaratri and others. Brahman priests perform all religious rituals for births, marriages and death. Specific periods of birth and death pollution are observed.' },
                                    { title: 'Pilgrimage & Ancestors', desc: 'Ancestor worship is prevalent. The Bania cremate their dead and the ashes are immersed in a river, preferably the sacred Ganges at Haridwar. The main centers of pilgrimage are Haridwar, Varanasi, Allahabad, Gangotri, Yamnotri, Kedarnath and Badrinath.' }
                                ].map((belief, idx) => (
                                    <div className="col-md-6" key={idx}>
                                        <div className="glass-card p-4 rounded-4 shadow-sm border-gold hover-lift h-100">
                                            <h5 className="text-heritage-maroon fw-bold mb-2">{belief.title}</h5>
                                            <p className="  mb-0 fs-6">{belief.desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                {/* 5. Customs Section */}
                <section className="container py-5">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <div className="img-wrapper rounded-4 shadow-elegant overflow-hidden hover-lift border-gold">
                                <img src={womanImg} alt="Traditional Indian Wedding" className="img-fluid w-100 img-heritage object-fit-cover" style={{ minHeight: '500px' }} />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <h2 className="fw-bold text-heritage-maroon mb-4">Vibrant Customs & Culture</h2>
                            <div className="d-flex flex-column gap-3">
                                {[
                                    { icon: 'bi-people', title: 'Arranged Marriages', desc: 'The Bania are monogamous and marriages are arranged by negotiation between parents and elders on both sides. Child marriages were common earlier but that has changed. Marriage symbols for women include sindur (vermilion mark), bindi (coloured dot on the forehead), glass bangles and finger and toe rings.' },
                                    { icon: 'bi-diagram-3', title: 'Joint Families & Inheritance', desc: 'Joint families are common among the Bania, though smaller families also exist. Inheritance is patrilineal - all sons inherit an equal share of parental property and the eldest son succeeds his father as head of the family. Daughters do not inherit anything.' },
                                    { icon: 'bi-suit-heart', title: 'Community Loyalty', desc: 'Bania families are known for the extreme loyalty towards their own community, caring and giving financially when needed.' },
                                    { icon: 'bi-calendar-event', title: 'Festivals & Cuisine', desc: 'The women sing folksongs and dance at marriages, births and festivals. They are known for their cooking and make rich dishes and sweets on special occasions.' }
                                ].map((custom, idx) => (
                                    <div className="glass-card p-3 rounded-4 shadow-sm border-gold hover-lift d-flex align-items-center gap-4" key={idx}>
                                        <div className="icon-gold-circle flex-shrink-0" style={{ width: '50px', height: '50px', fontSize: '20px' }}>
                                            <i className={`bi ${custom.icon}`}></i>
                                        </div>
                                        <div>
                                            <h5 className="text-heritage-maroon fw-bold mb-2">{custom.title}</h5>
                                            <p className=" mb-0 fs-6">{custom.desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                {/* 6. Community Influence Section */}
                <section className="container py-5 mb-5">
                    <div className="glass-card rounded-4 p-4 p-lg-5 shadow-elegant border-gold">
                        <div className="row g-5 align-items-center">
                            <div className="col-lg-6">
                                <h2 className="fw-bold text-heritage-maroon mb-4">A Wealthy & Influential Community</h2>
                                <p className=" mb-0 fs-6">
                                    The Bania are a wealthy and influential community. They control the economy of the country, as a majority of industrialists belong to this community.
                                </p>
                                <div className="row g-3 mt-2">
                                    {['Wealth Creation', 'Business Excellence', 'Industrial Growth', 'Economic Power'].map((trait, idx) => (
                                        <div className="col-sm-6" key={idx}>
                                            <div className="p-3 bg-white rounded-3 shadow-sm border-start border-4 border-warning hover-lift text-heritage-maroon fw-bold fs-5">
                                                <i className="bi bi-check-circle-fill text-heritage-gold me-2"></i> {trait}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="img-wrapper rounded-4 shadow-sm overflow-hidden hover-lift">
                                    <img src={economyimg} alt="Industrial Skyline" className="img-fluid w-100 object-fit-cover" style={{ height: '300px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 7. Footer Mission Banner */}
                <div className="mission-banner py-5 text-center shadow-lg position-relative">
                    <div className="container py-5 position-relative z-1">
                        <h1 className="display-5 fw-bold text-white text-uppercase" style={{ letterSpacing: '2px', textShadow: '2px 2px 10px rgba(0,0,0,0.5)' }}>
                            "Ekta, Seva aur Sanskaar <br /> ke saath Samaj ka Vikas"
                        </h1>
                    </div>
                </div>

            </div>

            {/* Main Objectives / Social Welfare Section */}
            <section id="objectives" className="portfolio section py-5 bg-light">
                <div className="container">
                    <h3 className="fw-bold mb-5 text-center fs-2 text-heritage-maroon" data-aos="fade-up">Our Main Objectives</h3>
                    <div className="row align-items-stretch gy-4">
                        
                        {/* President Box */}
                        <div className="col-lg-4" data-aos="fade-right">
                            <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden hover-lift">
                                <img src={rajeevImg} className="card-img-top object-fit-cover" alt="Rajeev Gupta - President" style={{ height: '350px', objectPosition: 'top' }} />
                                <div className="card-body p-4 bg-white text-center d-flex flex-column justify-content-center">
                                    <h5 className="fw-bold text-dark mb-1">Rajeev Gupta</h5>
                                    <p className=" small mb-0 fs-6 fw-medium text-uppercase tracking-wide">President, Mahawar Sabha (Reg.)</p>
                                </div>
                            </div>
                        </div>

                        {/* Objectives Boxes */}
                        <div className="col-lg-8">
    <div className="card border-0 shadow-sm rounded-4 h-100 p-4">
        
        <div className="mb-4">
            <span className="badge bg-warning text-dark px-3 py-2 mb-3">
                President's Vision
            </span>

            <h4 className="fw-bold text-heritage-maroon">
                Message from the President
            </h4>

            <p>
                As President of Mahawar Sabha, my vision is to strengthen our
                community through service, cultural preservation, and active
                youth participation while fostering unity and mutual support.
            </p>
        </div>

        <div className="border-start border-4 ps-4 mb-4">
            <div className="d-flex">
                <i className="bi bi-heart-pulse-fill text-danger me-3 fs-4"></i>
                <div>
                    <h6 className="fw-bold">Social Welfare</h6>
                    <p>
                        We are committed to helping needy families through
                        healthcare initiatives, food support, and charitable
                        programs.
                    </p>
                </div>
            </div>
        </div>

        <div className="border-start border-4 ps-4 mb-4">
            <div className="d-flex">
                <i className="bi bi-bank2 text-warning me-3 fs-4"></i>
                <div>
                    <h6 className="fw-bold">Preserving Our Heritage</h6>
                    <p>
                        Our traditions, values, and cultural identity must be
                        preserved and proudly passed to future generations.
                    </p>
                </div>
            </div>
        </div>

        <div className="border-start border-4 ps-4">
            <div className="d-flex">
                <i className="bi bi-people-fill text-primary me-3 fs-4"></i>
                <div>
                    <h6 className="fw-bold">Empowering Youth</h6>
                    <p>
                        We encourage young members to lead community initiatives,
                        volunteer actively, and become responsible future leaders.
                    </p>
                </div>
            </div>
        </div>

    </div>
</div>

                    </div>
                </div>
            </section>

            {/* Meet the Team Section */}
            <section id="team" className="team section py-5 bg-white">
                <div className="container section-title text-center mb-5" data-aos="fade-up">
                    <h2 className="mt-5 fw-bold text-dark">Meet Our Office Bearers</h2>
                    <div className="separator mx-auto mb-3"></div>
                    <p className="">A dedicated team working towards the unity and progress of our community.</p>
                </div>

                <div className="container" data-aos="fade-up" data-aos-delay="100">
                    {/* Office Bearers & Executive Members */}
                    <div className="row g-4 justify-content-center">
                        {/* President */}
                        <div className="col-4 col-md-4 col-lg-2">
                            <div className="team-member p-3 text-center">
                                <div className="profile-wrapper mx-auto mb-3">
                                    <img src={rajeevImg} alt="Rajeev Gupta" className="profile-img img-fluid" />
                                </div>
                                <h5 className="fw-bold text-dark mb-1 fs-6">Rajeev Gupta</h5>
                                <p className=" small mb-0 fs-6 fw-medium">President</p>
                            </div>
                        </div>

                        {/* Vice President */}
                        <div className="col-4 col-md-4 col-lg-2">
                            <div className="team-member p-3 text-center">
                                <div className="profile-wrapper mx-auto mb-3">
                                    <img src={nareshImg} alt="Naresh Gupta" className="profile-img img-fluid" />
                                </div>
                                <h5 className="fw-bold text-dark mb-1 fs-6">Naresh Gupta</h5>
                                <p className=" small mb-0 fs-6 fw-medium">Vice President</p>
                            </div>
                        </div>

                        {/* Secretary */}
                        <div className="col-4 col-md-4 col-lg-2">
                            <div className="team-member p-3 text-center">
                                <div className="profile-wrapper mx-auto mb-3">
                                    <img src={subodhImg} alt="Subodh Gupta" className="profile-img img-fluid" />
                                </div>
                                <h5 className="fw-bold text-dark mb-1 fs-6">Subodh Gupta</h5>
                                <p className=" small mb-0 fs-6 fw-medium">Secretary</p>
                            </div>
                        </div>

                        {/* Asst Secretary */}
                        <div className="col-4 col-md-4 col-lg-2">
                            <div className="team-member p-3 text-center">
                                <div className="profile-wrapper mx-auto mb-3">
                                    <img src={kapilImg} alt="Kapil Gupta" className="profile-img img-fluid" />
                                </div>
                                <h5 className="fw-bold text-dark mb-1 fs-6">Kapil Gupta</h5>
                                <p className=" small mb-0 fs-6 fw-medium">Asstt. Secretary</p>
                            </div>
                        </div>

                        {/* Treasurer */}
                        <div className="col-4 col-md-4 col-lg-2">
                            <div className="team-member p-3 text-center">
                                <div className="profile-wrapper mx-auto mb-3">
                                    <img src={amitImg} alt="Amit Gupta" className="profile-img img-fluid" />
                                </div>
                                <h5 className="fw-bold text-dark mb-1 fs-6">Amit Gupta</h5>
                                <p className=" small mb-0 fs-6 fw-medium">Treasurer</p>
                            </div>
                        </div>

                        {/* Executive Member */}
                        <div className="col-4 col-md-4 col-lg-2">
                            <div className="team-member p-3 text-center">
                                <div className="profile-wrapper mx-auto mb-3">
                                    <img src={niranjanImg} alt="Niranjan Lal Gupta" className="profile-img img-fluid" />
                                </div>
                                <h5 className="fw-bold text-dark mb-1 fs-6">Niranjan Lal Gupta</h5>
                                <p className=" small mb-0 fs-6 fw-medium">Executive Member</p>
                            </div>
                        </div>

                        {/* Executive Member */}
                        <div className="col-4 col-md-4 col-lg-2">
                            <div className="team-member p-3 text-center">
                                <div className="profile-wrapper mx-auto mb-3">
                                    <img src={anilImg} alt="Anil Kumar Gupta" className="profile-img img-fluid" />
                                </div>
                                <h5 className="fw-bold text-dark mb-1 fs-6">Anil Kumar Gupta</h5>
                                <p className=" small mb-0 fs-6 fw-medium">Executive Member</p>
                            </div>
                        </div>

                        {/* Executive Member */}
                        <div className="col-4 col-md-4 col-lg-2">
                            <div className="team-member p-3 text-center">
                                <div className="profile-wrapper mx-auto mb-3">
                                    <img src={tejparkashImg} alt="TejParkash" className="profile-img img-fluid" />
                                </div>
                                <h5 className="fw-bold text-dark mb-1 fs-6">TejParkash</h5>
                                <p className=" small mb-0 fs-6 fw-medium">Executive Member</p>
                            </div>
                        </div>

                        {/* Executive Member */}
                        <div className="col-4 col-md-4 col-lg-2">
                            <div className="team-member p-3 text-center">
                                <div className="profile-wrapper mx-auto mb-3">
                                    <img src={HemantguptaImg} alt="Hemant Gupta" className="profile-img img-fluid" />
                                </div>
                                <h5 className="fw-bold text-dark mb-1 fs-6">Hemant Gupta</h5>
                                <p className=" small mb-0 fs-6 fw-medium">Executive Member</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section id="faq" className="faq-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container py-4">
                    <div className="text-center mb-5" data-aos="fade-up">
                        <h2 className="fw-bold" style={{ color: '#0d1b2a' }}>Frequently Asked Questions</h2>
                        <div className="mx-auto mt-2" style={{ width: '60px', height: '3px', background: 'linear-gradient(to right, #8c1c13, #0d1b2a)', borderRadius: '2px' }}></div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            
                            {/* FAQ Item 1 */}
                            <div className="row faq-item align-items-start mb-4" data-aos="fade-up" data-aos-delay="100">
                                <div className="col-md-4 d-flex align-items-start mb-3 mb-md-0">
                                    <i className="bi bi-question-circle-fill faq-icon me-3 mt-1" style={{ color: '#e74c3c', fontSize: '1.5rem', transition: 'all 0.3s ease' }}></i>
                                    <h5 className="fw-bold mb-0 fs-6" style={{ color: '#0d1b2a', fontSize: '1.1rem', lineHeight: '1.4' }}>What is Mahawar Samaaj and what are its main objectives?</h5>
                                </div>
                                <div className="col-md-8">
                                    <p className=" mb-0 fs-6 lh-lg">Mahawar Samaaj is a community organization dedicated to social welfare, cultural preservation, and youth development. We conduct health camps, food distribution drives, cultural programs, and youth activities to support and unite our community members.</p>
                                </div>
                            </div>
                            <hr className=" opacity-25 mb-4" />

                            {/* FAQ Item 2 */}
                            <div className="row faq-item align-items-start mb-4" data-aos="fade-up" data-aos-delay="200">
                                <div className="col-md-4 d-flex align-items-start mb-3 mb-md-0">
                                    <i className="bi bi-question-circle-fill faq-icon me-3 mt-1" style={{ color: '#e74c3c', fontSize: '1.5rem', transition: 'all 0.3s ease' }}></i>
                                    <h5 className="fw-bold mb-0 fs-6" style={{ color: '#0d1b2a', fontSize: '1.1rem', lineHeight: '1.4' }}>Who can become a member of Mahawar Samaaj?</h5>
                                </div>
                                <div className="col-md-8">
                                    <p className=" mb-0 fs-6 lh-lg">Any individual belonging to the Mahawar community, or closely associated with it, who believes in our values of unity, service, and cultural preservation can become a member, subject to the guidelines of Mahawar Sabha (Reg.), Rewari.</p>
                                </div>
                            </div>
                            <hr className=" opacity-25 mb-4" />

                            {/* FAQ Item 3 */}
                            <div className="row faq-item align-items-start mb-4" data-aos="fade-up" data-aos-delay="300">
                                <div className="col-md-4 d-flex align-items-start mb-3 mb-md-0">
                                    <i className="bi bi-question-circle-fill faq-icon me-3 mt-1" style={{ color: '#e74c3c', fontSize: '1.5rem', transition: 'all 0.3s ease' }}></i>
                                    <h5 className="fw-bold mb-0 fs-6" style={{ color: '#0d1b2a', fontSize: '1.1rem', lineHeight: '1.4' }}>How does the Samaaj help underprivileged members of the community?</h5>
                                </div>
                                <div className="col-md-8">
                                    <p className=" mb-0 fs-6 lh-lg">We support underprivileged families through medical camps, financial assistance in emergencies, education support when possible, and food distribution during special drives or difficult times. The aim is to ensure dignity, basic support, and timely help for those in need.</p>
                                </div>
                            </div>
                            <hr className=" opacity-25 mb-4" />

                            {/* FAQ Item 4 */}
                            <div className="row faq-item align-items-start mb-4" data-aos="fade-up" data-aos-delay="400">
                                <div className="col-md-4 d-flex align-items-start mb-3 mb-md-0">
                                    <i className="bi bi-question-circle-fill faq-icon me-3 mt-1" style={{ color: '#e74c3c', fontSize: '1.5rem', transition: 'all 0.3s ease' }}></i>
                                    <h5 className="fw-bold mb-0 fs-6" style={{ color: '#0d1b2a', fontSize: '1.1rem', lineHeight: '1.4' }}>What types of cultural programs does Mahawar Samaaj organize?</h5>
                                </div>
                                <div className="col-md-8">
                                    <p className=" mb-0 fs-6 lh-lg">We organize traditional festivals, religious and social gatherings, felicitation programs, and cultural evenings that include bhajans, folk music, and community meals. These events help us preserve our customs and strengthen bonds across all age groups.</p>
                                </div>
                            </div>
                            <hr className=" opacity-25 mb-4" />

                            {/* FAQ Item 5 */}
                            <div className="row faq-item align-items-start" data-aos="fade-up" data-aos-delay="500">
                                <div className="col-md-4 d-flex align-items-start mb-3 mb-md-0">
                                    <i className="bi bi-question-circle-fill faq-icon me-3 mt-1" style={{ color: '#e74c3c', fontSize: '1.5rem', transition: 'all 0.3s ease' }}></i>
                                    <h5 className="fw-bold mb-0 fs-6" style={{ color: '#0d1b2a', fontSize: '1.1rem', lineHeight: '1.4' }}>How can youth participate and volunteer in Mahawar Samaaj activities?</h5>
                                </div>
                                <div className="col-md-8">
                                    <p className=" mb-0 fs-6 lh-lg">Young members can volunteer in health camps, charity drives, cultural events, and digital promotion of Samaaj activities. We also encourage them to take leadership roles in planning events, coordinating teams, and introducing new ideas that benefit the community.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </MainLayout>
    );
}

export default Home;
